import "../../../../common/styles/table.css";

/**
 * Skeleton loading component for Report page
 * Shows skeleton loaders for stats cards and table while data is loading
 */
const ReportSkeleton = () => {
  return (
    <>
      {/* Stats Cards Skeleton - matching DashboardStats layout */}
      <div className="row mb-4">
        {[...Array(4)].map((_, index) => (
          <div
            className="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-3"
            key={index}
          >
            <div
              className={`dashboard-stat-card ${
                index === 0
                  ? "dashboard-stat-card-purple"
                  : index === 1
                    ? "dashboard-stat-card-green"
                    : index === 2
                      ? "dashboard-stat-card-peach"
                      : "dashboard-stat-card-pastel-blue"
              }`}
            >
              <div className="skeleton-box report-stat-icon-skeleton"></div>
              <div className="dashboard-stat-content">
                <div
                  className="skeleton-box"
                  style={{
                    height: "14px",
                    width: "120px",
                    marginBottom: "8px",
                  }}
                ></div>
                <div
                  className="skeleton-box"
                  style={{
                    height: "28px",
                    width: "60px",
                  }}
                ></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Table Skeleton */}
      <div className="custom-table-container mt-3">
        <div className="custom-table-wrapper">
          <table className="table custom-table">
            <thead className="custom-table-head">
              <tr>
                {[
                  "Name",
                  "Classes",
                  "Students",
                  "Avg. Progress",
                  "Pass Rate",
                  "Lessons Assigned",
                ].map((header, i) => (
                  <th key={i}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {[...Array(5)].map((_, rowIndex) => (
                <tr key={rowIndex}>
                  {[...Array(6)].map((_, colIndex) => (
                    <td key={colIndex}>
                      <div
                        className="skeleton-box"
                        style={{
                          height: "16px",
                          width: colIndex === 0 ? "120px" : "50px",
                        }}
                      ></div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <style>{`
        @keyframes skeleton-pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
        .skeleton-box {
          background-color: #e0e0e0;
          border-radius: 4px;
          animation: skeleton-pulse 1.5s ease-in-out infinite;
          max-width: 100%;
        }
        .report-stat-icon-skeleton {
          width: 56px;
          height: 56px;
          border-radius: 10px;
          flex-shrink: 0;
        }
        @media (max-width: 768px) {
          .report-stat-icon-skeleton {
            width: 48px;
            height: 48px;
          }
        }
        @media (max-width: 576px) {
          .report-stat-icon-skeleton {
            width: 40px;
            height: 40px;
          }
        }
      `}</style>
    </>
  );
};

export default ReportSkeleton;
